import React from 'react';
import { Modal } from 'react-bootstrap';
import { Warning48Filled } from '@fluentui/react-icons';
import styles from './DoubleConfirmationModal.module.css';

const SimpleAlertModal = ({ open, onClose, message }) => {
    return (
        <Modal centered show={open} onHide={onClose} className={styles.modalMainBody}>
            <Modal.Body className={styles.confirmationModalBody}>
                <div className={styles.confirmationModalMsg}>
                    <div className="mb-4 text-center">
                        <Warning48Filled color="var(--Brand-Primary)" />
                    </div>
                    <p className={styles.message}>{message}</p>
                    <div className="d-flex justify-content-center align-items-center">
                        <button
                            type="button"
                            onClick={onClose}
                            className={styles.secondaryBtn}>
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SimpleAlertModal;

